<template>
    <div>
        <button
            @click="addTTPK"
            class="px-4 py-2 bg-green-500 text-white rounded mb-5"
        >
            Tambah TTPK
        </button>
        <div
            v-for="(ttpk, index) in ttpkList"
            :key="ttpk.id || index"
            class="ttpk-entry mb-3"
        >
            <div class="lg:w-full md:w-full">
                <div class="flex items-center gap-2">
                    <Dropdown
                        class="w-full"
                        v-model="ttpkList[index].id"
                        :options="filteredTTPKOptions(ttpk.id)"
                        optionLabel="fullname"
                        optionValue="id"
                        filter
                        filterBy="fullname"
                        @filter="fetchTTPK"
                        @change="validateUniqueness(index)"
                        placeholder="Pilih Tim Teknis Pelaksanaan Kontrak"
                    />
                    <button
                        @click="removeTTPK(index)"
                        class="px-4 py-2 bg-red-500 text-white rounded ml-2"
                    >
                        Hapus
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import Dropdown from "primevue/dropdown";
import axios from "axios";

export default defineComponent({
    components: {
        Dropdown,
    },
    props: {
        list_ttpk: Array,
        ttpk_id : String,
    },
    data() {
        const ttpkInitialList = this.list_ttpk
            ? this.list_ttpk.map((item, idx) => ({
                ...item,
                ttpkUniqueId: item.ttpkUniqueId || this.ttpkGenerateUniqueId(),
                ttpkDisplayIndex: idx + 1
            }))
            : [];
        return {
            ttpkOptions: [],
            ttpkList: ttpkInitialList,
            ttpkNextIndex: (ttpkInitialList.length > 0)
                ? Math.max(...ttpkInitialList.map(item => item.ttpkDisplayIndex || 0)) + 1
                : 1
        };
    },
    watch: {
        list_ttpk: {
            handler(ttpkNewValue) {
                if (ttpkNewValue) {
                    // Block recursive updates by checking if the internal change is happening
                    if (this._internalUpdate) return;
                    
                    // Preserve ttpkUniqueIds if present, generate new ones if not
                    this.ttpkList = ttpkNewValue.map((item, idx) => ({
                        ...item,
                        ttpkUniqueId: item.ttpkUniqueId || this.ttpkGenerateUniqueId(),
                        ttpkDisplayIndex: item.ttpkDisplayIndex || (idx + 1)
                    }));
                    
                    // Update ttpkNextIndex based on highest current ttpkDisplayIndex
                    if (this.ttpkList.length > 0) {
                        this.ttpkNextIndex = Math.max(
                            ...this.ttpkList.map(item => item.ttpkDisplayIndex || 0)
                        ) + 1;
                    }
                } else {
                    this.ttpkList = [];
                    this.ttpkNextIndex = 1;
                }
            },
            deep: true,
        },
        ttpkList: {
            handler(ttpkNewValue) {
                // Prevent recursive updates by setting a flag
                this._internalUpdate = true;
                // Emit the updated ttpkList to the parent component
                this.$emit("update:list_ttpk", ttpkNewValue);
                // Reset flag after this update cycle
                this.$nextTick(() => {
                    this._internalUpdate = false;
                });
            },
            deep: true,
        },
    },
    mounted() {
        this.fetchTTPK({ value: "" });
    },
    methods: {
        ttpkGenerateUniqueId(){
            return Date.now() + '-' + Math.floor(Math.random() * 100);
        },
        addTTPK() {
            this.ttpkList.push({
                id: null,
                ttpkUniqueId : this.ttpkGenerateUniqueId(),
                ttpkDisplayIndex : this.ttpkNextIndex
            });
            this.ttpkNextIndex++;
        },
        removeTTPK(ttpkIndex) {
            this.ttpkList.splice(ttpkIndex, 1);
        },
        async fetchTTPK(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/organisasi_pengadaan/search_ttpk",
                    {
                        params: {
                            keyword: event.value || "",
                        },
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.ttpkOptions = response.data;
                }
            } catch (error) {
                console.error("Error fetching ttpk:", error);
            }
        },
        filteredTTPKOptions(ttpkCurrentId) {
            // Ensure the currently selected option is available in the dropdown options
            return this.ttpkOptions.concat(
                this.ttpkList.filter(
                    (p) =>
                        p.id === ttpkCurrentId &&
                        !this.ttpkOptions.some(
                            (option) => option.id === ttpkCurrentId
                        )
                )
            );
        },
        validateUniqueness(ttpkCurrentIndex) {
            const ttpkCurrentId = this.ttpkList[ttpkCurrentIndex]?.id;
            if (
                ttpkCurrentId &&
                this.ttpkList.filter(
                    (ttpk) => ttpk.id === ttpkCurrentId
                ).length > 1
            ) {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "TTPK duplikat terdeteksi. Pastikan setiap ttpk unik.",
                    life: 3000,
                });
                this.ttpkList[ttpkCurrentIndex].id = null;
            }
        },
    },
});
</script>
